export const WEBMAP_TERRAIN_ID_PREFIX = 'webmap-terrain';
